import { ITaxClassification } from '@medely/types';
import useGraphQLRequest from './useGraphQLRequest';
import { useQuery } from '@tanstack/react-query';
import { GET_TAX_CLASSIFICATIONS } from '@mp/graphql';

const useTaxClassifications = (): {
  taxClassifications: ITaxClassification[];
  isLoading: boolean;
} => {
  const { request } = useGraphQLRequest();

  const fetchTaxClassifications = async () => {
    const result = (await request(GET_TAX_CLASSIFICATIONS)) as {
      taxClassifications: ITaxClassification[];
    };
    return result.taxClassifications;
  };

  const { data = [], isLoading } = useQuery(['taxClassifications'], fetchTaxClassifications);

  return {
    taxClassifications: data || [],
    isLoading,
  };
};

export default useTaxClassifications;
